import * as React from 'react';
export const uobSvg = React.forwardRef(function uobSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#E1091D',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.114 4c.451.01 1.017.094 1.09.535l.009.1-.001 10.023h2.117V4.635c0-.528.677-.624 1.112-.635h.46c.406.01 1.022.094 1.103.535l.008.1v10.023h2.047V4.635c0-.528.677-.624 1.114-.635h.387c.406.01 1.022.094 1.103.535l.009.1-.001 10.023h2.117V4.635c0-.528.677-.624 1.114-.635h.395c.459.01 1.08.092 1.108.534l-.004.1v10.024h2.964c.528 0 .624.677.635 1.112v.371c0 .424-.07 1.2-.635 1.2h-2.964v10.024c0 .133 0 .52-.892.62l-.167.015h-.353c-.395 0-1.098-.061-1.19-.529l-.01-.106-.001-10.024h-2.117v10.05c-.002.152-.052.5-.891.594l-.167.015h-.354c-.395 0-1.098-.061-1.19-.529l-.01-.106V17.34h-2.047v10.05c-.003.152-.052.5-.892.594l-.166.015h-.424c-.395 0-1.098-.061-1.19-.529l-.01-.106-.001-10.024h-2.117v10.05c-.002.152-.052.5-.891.594L9.154 28H8.8c-.396 0-1.099-.061-1.19-.529l-.01-.106V17.34H4.61c-.153-.003-.5-.052-.595-.892L4 16.282v-.423c0-.424.07-1.2.635-1.2l2.965-.001V4.635c0-.528.615-.624 1.101-.635h.413Z',
      fill: '#fff',
    }),
  );
});
uobSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var uob = {
  category: 'brand',
  colorable: false,
  name: 'uob',
  svg: uobSvg,
};
